export var WebGLMode;
(function (WebGLMode) {
    WebGLMode[WebGLMode["Auto"] = 0] = "Auto";
    WebGLMode[WebGLMode["WebGL2"] = 1] = "WebGL2";
    WebGLMode[WebGLMode["WebGL1"] = 2] = "WebGL1";
})(WebGLMode || (WebGLMode = {}));
